<template>
  <Dialog v-if="isActive" v-show="isActive" class="backdrop-blur-sm" :extend-class="['md:max-w-3xl mb-[2rem]']">
    <div class="bg-white rounded-lg w-full">
      <div class="p-8">
        <div class="flex justify-between items-center mb-6">
          <h2 class="text-3xl font-medium">{{ actionType == 'add' ? 'Add' : 'Edit' }} project</h2>
          <img src="@/assets/icons/times.svg" class="w-4 cursor-pointer" alt="" @click="$emit('close')" />
        </div>

        <div class="grid grid-cols-1 gap-4 md:grid-cols-2 mb-4">
          <div>
            <Input type="text" label="Project title" placeholder="Project titlte" v-model="project.title" />
          </div>

          <div>
            <Input type="url" label="Project website" placeholder="https://project..." v-model="project.website" />
          </div>
        </div>

        <div class="mb-4">
          <v-select
            multiple
            v-model="project.skills"
            :disabled="project.skills.length >= 5"
            :options="[]"
            placeholder="Select up to 3 skills"
            taggable
            push-tags
          >
            <!-- eslint-disable-next-line vue/no-unused-vars  -->
            <template #no-options="item">
              <div>Type and press enter to add a skill</div>
            </template>
          </v-select>
        </div>

        <div class="mb-4">
          <Input type="textarea" label="Description" placeholder="Select" v-model="project.project_details" />
        </div>

        <!-- <div class="mb-6">
          <p class="mb-2 text-sm">Add project photo</p>
          <label for="photo" class="w-full block p-6 py-3 rounded-lg border border-gray-400 border-dashed cursor-pointer">
            <div class="flex items-center">
              <input type="file" id="photo" class="sr-only" />
              <img src="" alt="" />

              <div>
                <p class="text-lg">Drag & drop here or <span class="text-blue-700">Browse</span> to upload</p>
                <small class="text-gray-500">Min 200px X 200px. JPG or PNG files of max 2MB.</small>
              </div>
            </div>
          </label>
        </div> -->

        <div class="flex justify-end">
          <Button data-test="login-button" label="Save" color="primary" type="button" class="px-8 rounded-xl" @click="$emit('confirm')" />
        </div>
      </div>
    </div>
  </Dialog>
</template>

<script setup>
import Dialog from '@/components/Dialog.vue';
import { onMounted } from 'vue';
import Input from '../form/Input.vue';
import Button from '../Button.vue';

const props = defineProps({
  isActive: { type: Boolean, default: false },
  project: { type: Object },
  actionType: { type: String, default: 'add' },
});

onMounted(() => {});
</script>
